<template>
  <div>
    <headers />
    <mytop/>
    <div class="containers menulrbox clearfix">
      <div class="menuleft">
        <el-row class="tac">
          <el-col :span="24">
            <el-menu
              :default-active="active"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
              active-text-color="#FFFFFF"
            >
              <router-link tag="div" :to="{path:'/settings/pdetails',query:{index:'0'}}">
                <el-menu-item index="0">
                  <i class="el-icon-s-custom"></i>
                  <span slot="title">个人信息</span>
                </el-menu-item>
              </router-link>

              <router-link tag="div" :to="{path:'/settings/password',query:{index:'1'}}">
                <el-menu-item index="1">
                  <i class="el-icon-lock"></i>
                  <span slot="title">修改密码</span>
                </el-menu-item>
              </router-link>
              <router-link tag="div" :to="{path:'/settings/paypassword',query:{index:'2'}}">
                <el-menu-item index="2">
                  <i class="el-icon-lock"></i>
                  <span slot="title">支付密码</span>
                </el-menu-item>
              </router-link>
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <div class="menuright">
        <router-view />
      </div>
    </div>
    <footers/>
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import { Row, Col, Menu, MenuItemGroup, MenuItem } from "element-ui";
import mytop from "@/components/mytop.vue";
export default {
  components: {
    headers,
    footers,
    mytop,
    [Menu.name]: Menu,
    [MenuItemGroup.name]: MenuItemGroup,
    [MenuItem.name]: MenuItem,
    [Row.name]: Row,
    [Col.name]: Col
  },
  data() {
    return {
      active: "0",
    };
  },
  beforeRouteUpdate(to, from, next) {
    
    if(to.query.index){
      this.active = to.query.index.toString();
    }else{
      this.active = '0'
    }
    
    next();
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  },
  mounted() {
    if (this.$route.query.index) {
      this.active = this.$route.query.index;
    } else {
      this.active = "0";
    }
  }
};
</script>

<style scoped>
@import "~@/assets/css/my.css";
</style>